export const NAVIGATION_MAIN_BURGERPOSITION_LEFT = "left";
export const NAVIGATION_MAIN_BURGERPOSITION_RIGHT = "right";

export const NAVIGATION_MAIN_BURGERPOSITIONS = [
  NAVIGATION_MAIN_BURGERPOSITION_LEFT,
  NAVIGATION_MAIN_BURGERPOSITION_RIGHT
] as const;
